// extracted by mini-css-extract-plugin
export default {"wrapper":"kycPreview_wrapper__xcfKb","title":"kycPreview_title__uOhND"};